import { debounce } from 'lodash';

const SELECTOR = '.global-top-bar';

export default function () {
    const element = document.querySelector(SELECTOR);

    if (!element) {
        return;
    }

    const setGroupHeight = () => {
        const { height } = element.getBoundingClientRect();

        document.documentElement.style.setProperty(
            '--global-top-bar-height', `${height}px`
        );
    }

    window.addEventListener('resize', debounce(setGroupHeight, 250));

    setGroupHeight();
}
